export default __webpack_public_path__ + "static/media/carepoolInspectionPoints.6ae8aecf.png";